










import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import { GanttChartData } from '@/model/dashboard/GanttChartData'
import { DashboardGanttEmployeeList } from '@/types'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

am4core.useTheme(am4themes_animated)

interface ComponentData {
  chart: any
  translate: any
}

export default Vue.extend({
  name: 'GanttChartScheduleWeek',

  props: {
    ganttLabelScheduleWeek: String,
    ganttChartScheduleWeekData: {
      type: Array as () => Array<GanttChartData>
    },
    employees: {
      type: Array as () => DashboardGanttEmployeeList
    },
    ganttDateScheduleWeek: String
  },

  data (): ComponentData {
    return {
      chart: undefined,
      translate: {
        Sun: this.$i18n.t('dashboardPage.Sun').toString(),
        Mon: this.$i18n.t('dashboardPage.Mon').toString(),
        Tue: this.$i18n.t('dashboardPage.Tue').toString(),
        Wed: this.$i18n.t('dashboardPage.Wed').toString(),
        Thu: this.$i18n.t('dashboardPage.Thu').toString(),
        Fri: this.$i18n.t('dashboardPage.Fri').toString(),
        Sat: this.$i18n.t('dashboardPage.Sat').toString(),
      }
    }
  },

  watch: {
    selectedLocale(): void {
      this.translate.Sun = this.$i18n.t('dashboardPage.Sun').toString()
      this.translate.Mon = this.$i18n.t('dashboardPage.Mon').toString()
      this.translate.Tue = this.$i18n.t('dashboardPage.Tue').toString()
      this.translate.Wed = this.$i18n.t('dashboardPage.Wed').toString()
      this.translate.Thu = this.$i18n.t('dashboardPage.Thu').toString()
      this.translate.Fri = this.$i18n.t('dashboardPage.Fri').toString()
      this.translate.Sat = this.$i18n.t('dashboardPage.Sat').toString()
      this.createChart()
    }
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    createChart (): any {
      //@ts-ignore
      let chart = am4core.create(this.$refs.ganttChartWeek, am4charts.XYChart)
      chart.dateFormatter.language = new am4core.Language();
      chart.dateFormatter.language.locale = this.translate;
      chart.hiddenState.properties.opacity = 0

      chart.paddingRight = 30
      chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd HH:mm'

      chart.data = this.employees
      const data = this.ganttChartScheduleWeekData

      let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = 'name'
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.inversed = true
      categoryAxis.renderer.minGridDistance = 30

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis())

      dateAxis.dateFormatter.dateFormat = 'yyyy-MM-dd HH:mm'
      dateAxis.renderer.minGridDistance = 55
      //dateAxis.baseInterval = { count: 24, timeUnit: 'hour' }
      dateAxis.min = data[0] ? moment(this.ganttChartScheduleWeekData[0].fromDate).startOf('isoWeek').toDate().getTime() : ''
      dateAxis.max = data[0] ? moment(this.ganttChartScheduleWeekData[0].fromDate).endOf('isoWeek').toDate().getTime(): ''
      dateAxis.strictMinMax = true
      dateAxis.renderer.tooltipLocation = 0;
      dateAxis.dateFormats.setKey("day", "EEE");


      function createSeries (field: string, name: string): any {

        if (name === 'shift') {
          let series1 = chart.series.push(new am4charts.ColumnSeries())
          series1.name = name
          series1.columns.template.height = am4core.percent(90)
          series1.columns.template.tooltipText = '{name}: [bold]{label}'
          series1.dataFields.openDateX = 'fromDate'
          series1.dataFields.dateX = 'toDate'
          series1.dataFields.categoryY = 'name'
          series1.columns.template.propertyFields.fill = 'color' // get color from data
          series1.columns.template.propertyFields.stroke = 'color'
          series1.columns.template.strokeOpacity = 0
          series1.data = data.filter((item: GanttChartData) => item.type === name)

          let valueLabel = series1.bullets.push(new am4charts.LabelBullet())
          valueLabel.label.text = '[font-size:14px]{label}'
        }
      }

      createSeries('shift', 'shift')
      createSeries('absences', 'absences')
      createSeries('calendar', 'calendar')

      let cellSize = 30
      chart.events.on('datavalidated', function (ev: any) {

        // Get objects of interest
        let chart = ev.target
        let categoryAxis = chart.yAxes.getIndex(0)

        // Calculate how we need to adjust chart height
        let adjustHeight = chart.data.length * cellSize - categoryAxis.pixelHeight

        // get current chart height
        let targetHeight = chart.pixelHeight + adjustHeight

        // Set it on chart's container
        chart.svgContainer.htmlElement.style.height = targetHeight + 'px'

      })

      this.chart = chart
    }
  },

  mounted () {
    this.createChart()
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }

})
